var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChildRelationship = function SvgChildRelationship(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 2,
    y: 2,
    fill: "#737D8C",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737D8C",
    fillRule: "evenodd",
    d: "M5.5 11.25a.75.75 0 0 1-.75-.75V8a.75.75 0 0 0-1.5 0v2.5a2.25 2.25 0 0 0 2.25 2.25H8a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 10,
    fill: "#737D8C",
    rx: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChildRelationship);
export { ForwardRef as Icon };
export default "img/element-icons/child-relationship.f8cfd49.svg";